<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <!-- NOTE TOOLBAR -->
      <div>
        <v-toolbar dark color="primary" :elevation="elevation">
          <v-toolbar-title>รายละเอียด</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="Close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </div>

      <!-- NOTE CONTENT -->
      <div class="main-layout">
        <div class="grid-gallery">
          <div class="grid-item-series">
            <v-card :elevation="elevation" class="card-item">
              <v-card-title>รายละเอียด</v-card-title>
              <v-card-text class="card-text">
                <v-list>
                  <v-list-item
                    two-line
                    v-for="item in details"
                    :key="item.text"
                  >
                    <v-list-item-content class="pt-0">
                      <v-list-item-title>
                        <!-- {{ localItems[index]?.[item.value] || "-" }} -->
                        {{
                          item.value != "create_date"
                            ? localItems[index]?.[item.value] || "-"
                            : $moment(localItems[index]?.[item.value]).format(
                                "DD-MM-YYYY HH:mm"
                              )
                        }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="py-1">
                        {{ item.text }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </div>
          <!-- กรณียังไม่ได้ Click -->
          <div
            :class="[
              `${
                checkStateClickTab != 'CT-SCAN'
                  ? 'grid-item grid-item-single'
                  : 'grid-item'
              }`,
            ]"
            id="viewer-image"
          >
            <v-card :elevation="elevation" style="height: 100%; width: 100">
              <!-- <conferenceCall/> -->

              <!-- <squareOnImage
                v-if="localItems[0] != undefined && localItems[0].type == 'single' "
                :src="localItems[index]?.src"
                :boxs="boxs"
                :brightness="localItems[index]?.adjusts.brightness"
                :contrast="localItems[index]?.adjusts.contrast"
                :loading="loading"
              >
              </squareOnImage> -->

              <!-- <dwv
                v-else
                v-model="listDicomFile"
                @drawRectangle="onDrawRectangle"
              >
              </dwv> -->
              <dwv
                v-model="localItems"
                :activeTools="activeTools"
                :annotation="jsonState"
                ref="dwv"
              >
              </dwv>
            </v-card>
            <!-- กดประชุม -->
            <!-- <v-card class="meet-layout" v-show="!status">
              <u-user-calling v-model="credential" ref="call" @end="EndCalling" disableRecordBtn disableAutoLeave />
            </v-card> -->
          </div>
          <div class="grid-item" v-show="checkStateClickTab != 'CT-SCAN'">
            <v-card :elevation="elevation" class="card-item">
              <v-card-title>การวินิจฉัยโดย AI</v-card-title>
              <v-card-text class="card-text">
                <v-list dense>
                  <v-list-group
                    v-for="item in copyLocalItems[index]?.processes"
                    :key="item.process_id"
                    v-model="item.active"
                    :append-icon="item.results.length > 0 ? 'mdi-chevron-down' : ''"
                    no-action
                    :disabled="item.results.length > 0 ? false : true"
                    :color="item.results.length > 0 ? 'warning' : 'success'"
                    multiple
                  >
                    <template v-slot:prependIcon>
                      <v-icon
                        v-if="item.status == 'success'"
                        :class="
                          item.results.length > 0
                            ? 'text-warning'
                            : 'text-disabled'
                        "
                      >
                        {{
                          item.results.length > 0
                            ? "mdi-alert-outline"
                            : "mdi-check-circle-outline"
                        }}
                      </v-icon>
                      <v-progress-circular
                        v-else
                        size="22"
                        indeterminate
                        color="primary"
                      >
                      </v-progress-circular>
                    </template>

                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list
                        :class="
                            item.results.length > 0
                              ? 'text-warning'
                              : 'text-disabled'
                          "
                          v-text="item.name"
                        ></v-list>
                      </v-list-item-content>
                    </template>

                    <v-list-item
                      v-for="child in item.results"
                      :key="child.result_id"
                      :id="child.result_id"
                    >
                      <!-- <v-list-item-icon>
                        </v-list-item-icon> -->

                      <v-list-item-icon>
                        <v-checkbox
                          v-model="boxs"
                          color="primary"
                          :value="child"
                          hide-details
                          class="mr-0 mt-0"
                        >
                        </v-checkbox>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title>
                          {{ child.confident }} %
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </v-card-text>
            </v-card>
          </div>
          <div
            :class="[
              `${
                checkStateClickTab != 'CT-SCAN'
                  ? 'grid-item'
                  : 'grid-item-series'
              }`,
            ]"
          >
            <v-card :elevation="elevation" class="card-item">
              <v-card-title>การวินิจฉัยโดย แพทย์ </v-card-title>
              <!-- tab ความเห็น, ประชุม, ไฟล์ -->
              <!-- <div> -->
              <v-tabs v-model="tabSelectedFeatures">
                <v-tab
                  v-for="item in itemSelectedFeatures"
                  :key="item.name"
                  @click="selectedFeatures(item.value)"
                  style="font-weight: 500; font-size: 16px"
                >
                  {{ item.name }}
                  <!-- <span :class="item.value === checkStateClickTab ? 'counter-typetab-click' : 'counter-typetab-nonclick'">
                        {{countTotolBox}}
                      </span> -->
                </v-tab>
              </v-tabs>
              <!-- </div> -->
              <div
                class="layout-conference"
                v-show="checkStateSelectedFeatures === 1"
              >
                <!-- <u-user-calling v-show="checkStateSelectedFeatures === 1" v-model="credential" ref="call" @end="EndCalling" disableRecordBtn disableAutoLeave /> -->
                <conferenceCall v-show="checkStateSelectedFeatures === 1" />
              </div>
              <div
                class="layout-comment"
                v-show="checkStateSelectedFeatures === 2"
              >
                <!-- <u-user-calling v-show="checkStateSelectedFeatures === 1" v-model="credential" ref="call" @end="EndCalling" disableRecordBtn disableAutoLeave /> -->
                <chatbox
                  :items="localItems[index]?.comments"
                  :job_id="localItems[index]?.job_id"
                  :hospital_id="hospital_id"
                  :currentUser="this.storeGetUserInfo.user_id"
                  @create="onCreateComment"
                  @createSub="onCreateSubComment"
                  @update="onUpdateComment"
                  @deleteMain="onDeleteMainComment"
                  @deleteSub="onDeleteSubComment"
                ></chatbox>
              </div>
            </v-card>
          </div>
          <!-- <div class="grid-item" v-show="checkStateClickTab != 'CT-SCAN'">
            <v-card :elevation="elevation" class="card-item">
              <v-card-title>ปรับแต่ง</v-card-title>
              <v-card-text class="card-text">
                <v-list v-if="localItems.length > 0">
                  <v-list-item
                    two-line
                    v-for="item in adjusts"
                    :key="item.text"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-slider
                          v-model="localItems[index].adjusts[item.key]"
                          step="10"
                          ticks="always"
                          tick-size="3"
                          color="primary"
                          max="200"
                          min="0"
                        >
                        </v-slider>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ item.text }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </div> -->
          <!-- <div class="grid-item" v-if="items.length > 1">
            <v-card :elevation="elevation" style="height: 100%; width: 100">
              <v-row
                justify="space-between"
                align="center"
                class="pa-0 ma-0"
                style="width: 100%; height: 100%; display: flex"
              >
                <v-col>
                  <v-btn
                    x-large
                    icon
                    color="primary"
                    @click="() => (index--, (boxs = []))"
                    :disabled="index <= 0"
                  >
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </v-col>
                <v-col style="text-align: center">
                  {{ index + 1 }} of {{ localItems.length }}
                </v-col>
                <v-col style="text-align: end">
                  <v-btn
                    x-large
                    icon
                    color="primary"
                    @click="() => (index++, (boxs = []))"
                    :disabled="items.length - 1 <= index"
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>  -->
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
// REF https://codepen.io/wellingguzman/pen/BxVKRE?editors=1010
// import squareOnImage from '@/components/squareOnImage_v2.vue'
import chatbox from '@/components/ChatBox.vue'
import dwv from '@/components/Dwv.vue'
import { mapGetters } from 'vuex'
import conferenceCall from '../ConferenceCall.vue'
export default {
  components: {
    // squareOnImage,
    chatbox,
    conferenceCall,
    dwv
  },
  data () {
    return {
      jsonState: null,
      localjsonState: null,
      index: 0,
      loading: false,
      boxs: [],
      elevation: 4, // TODO Global elevation all Card
      // dialog: true,
      notifications: false,
      sound: true,
      widgets: false,
      details: [
        { text: 'ID', value: 'job_id' },
        { text: 'H/N', value: 'po' },
        { text: 'ชื่อผู้ป่วย', value: 'pn' },
        { text: 'วันที่ x-ray', value: 'da' },
        // { text: 'ชื่อไฟล์', value: 'xxxxxxxxxxxx.jpg' },
        { text: 'วันที่อัปโหลด', value: 'create_date' },
        // { text: 'ผู้อัปโหลด', value: 'create_by' },
        { text: 'Type', value: 'type' },
        { text: 'Series ID', value: 'series_id' }
      ],
      adjusts: [
        { text: 'ความสว่าง', value: 100, key: 'brightness' },
        { text: 'ความเข้ม', value: 100, key: 'contrast' }
      ],
      elementViewImage: null,
      // diagnosis: [
      //   {
      //     text: 'Cardiomegaly',
      //     value: 50,
      //     active: false,
      //     items: [
      //       {
      //         text: 'A1',
      //         value: 50,
      //         xy: [
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 10 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 20 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 30 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 40 }
      //         ]
      //       }
      //     ]
      //   },
      //   {
      //     text: 'Pneumothorax',
      //     value: 50,
      //     active: false,
      //     items: [
      //       // {
      //       //   text: 'A1',
      //       //   value: 50,
      //       //   xy: [
      //       //     { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 10 },
      //       //     { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 20 },
      //       //     { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 30 },
      //       //     { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 40 }
      //       //   ]
      //       // }
      //     ]
      //   },
      //   {
      //     text: 'Tuberculosis',
      //     value: 50,
      //     active: false,
      //     items: [
      //       {
      //         text: 'E1',
      //         value: 50,
      //         xy: [
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 10 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 20 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 30 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 40 }
      //         ]
      //       },
      //       {
      //         text: 'E2',
      //         value: 50,
      //         xy: [
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 10 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 20 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 30 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 40 }
      //         ]
      //       },
      //       {
      //         text: 'E3',
      //         value: 50,
      //         xy: [
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 10 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 20 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 30 },
      //           { xmin: 0, ymin: 0, xmax: 100, ymax: 100, confident: 40 }
      //         ]
      //       }
      //     ]
      //   }
      // ]
      // meet
      // tab
      tabSelectedFeatures: null,
      itemSelectedFeatures: [
        { name: 'การประชุม', value: 'conference' },
        { name: 'ความคิดเห็น', value: 'comment' }
      ],
      checkStateSelectedFeatures: 1,
      copyLocalItems: []
    }
  },
  created () {
    this.channel_name = this.$route.params.channel_name || ''
  },
  props: {
    hospital_id: {
      type: String
    },
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    },
    items: {
      type: Array,
      default: () => [
        // {
        //   job_id: '',
        //   po: '',
        //   pn: '',
        //   da: '',
        //   create_date: '',
        //   create_by: '',
        //   series_id: '',
        //   type: ''
        // }
      ]
    },
    detailItem: {
      type: Object,
      default: () => {
        return {
          job_id: '-',
          po: '-',
          pn: '-',
          da: '-',
          create_date: '-',
          create_by: '-'
        }
      }
    },
    src: {
      type: String,
      default: ''
    },
    processes: {
      type: Array,
      default: () => []
    },
    checkStateClickTab: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['storeGetUserInfo']),
    // boxs () {
    //   // { xmin: 100, ymin: 100, xmax: 200, ymax: 200, confident: 100 }
    //   let b = Object.assign([])
    //   for (const i of this.processes) {
    //     if (i.results.length > 0) {
    //       b = [...b, ...i.results]
    //     }
    //   }
    //   return b
    // },
    localItems: {
      get () {
        return this.items
      },
      set (val) {
        this.$emit('update:items', val)
        return val
      }
    },
    dialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        return val
      }
    },
    listDicomFile () {
      return this.localItems.map((e) => e.dicom)
    },
    activeTools () {
      if (this.localItems[0] && this.localItems[0].type === 'single') {
        return [
          'zoomandpan',
          'windowlevel',
          'reset',
          'cm',
          'drawrect',
          'drawellipse',
          'drawruler',
          'drawcircle',
          'drawarrow',
          'drawprotractor',
          'drawroi',
          'drawfreehand',
          'info'
        ]
      } else {
        return [
          'scroll',
          'zoomandpan',
          'windowlevel',
          'reset',
          'cm',
          'wl',
          'drawrect',
          'drawellipse',
          'drawruler',
          'drawcircle',
          'drawarrow',
          'drawprotractor',
          'drawroi',
          'drawfreehand',
          'info',
          'side'
        ]
      }
    }
  },
  watch: {
    // UKRIT
    boxs: {
      deep: true,
      // immediate: true,
      handler (v) {
        // console.log('🚀 ~ handler ~ v :', v)
        if (this.localjsonState == null) {
          this.localjsonState = this.$refs.dwv.getJsonState()
          this.localjsonState.drawings.children.push({
            attrs: {
              id: '#2-0',
              name: 'position-group',
              visible: false
            },
            className: 'Group',
            children: []
          })
          // console.log('🚀 ~ handler ~ this.jsonState: null : ==>', this.localjsonState)
        }
        this.$refs.dwv.deleteDraws()
        this.localjsonState = JSON.parse(
          JSON.stringify(this.processJsonState(this.localjsonState, v))
        )
        this.$refs.dwv.applyJsonState(this.localjsonState)
        // console.log('🚀 ~ handler ~ this.jsonState:', this.localjsonState)
      }
    },
    items: {
      deep: true,
      immediate: true,
      handler (v) {
        this.copyLocalItems = JSON.parse(JSON.stringify(this.items))
      }
    },
    dialog (newVal) {
      if (newVal) {
        this.loading = true

        setTimeout(() => {
          this.loading = false

          this.elementViewImage = document.getElementById('viewer-image')
          if (this.elementViewImage) {
            this.elementViewImage.addEventListener(
              'mouseover',
              this.mouseOver,
              false
            )

            this.elementViewImage.addEventListener(
              'mouseleave',
              this.mouseLeave,
              false
            )
          }
        }, 2500)
      }
    }
  },
  methods: {
    // NOTE เป็น Function ในการเพิ่ม Draw
    processJsonState (data = null, options = []) {
      if (data == null) return console.error('processJsonState : data is null')
      // FIX Clear value
      data.drawings.children[0].children = JSON.parse(JSON.stringify([]))
      data.drawingsDetails = JSON.parse(JSON.stringify({}))
      options.forEach((e) => {
        const { drawing, drawingsDetails } = this.generateDataJsonState(
          e.result_id,
          e
        )
        data.drawings.children[0].children.push(drawing)
        data.drawingsDetails = { ...data.drawingsDetails, ...drawingsDetails }
        // console.log('🚀 ~ options.forEach ~ drawingsDetails:', drawingsDetails)
        // console.log('🚀 ~ options.forEach ~ drawing:', drawing)
      })
      return data
    },
    generateDataJsonState (
      id,
      options = { xmin: 0, xmax: 0, ymin: 0, ymax: 0, name: '', confident: 0 }
    ) {
      const width = options.xmax - options.xmin
      const height = options.ymax - options.ymin
      const drawing = {
        className: 'Group',
        children: [
          {
            attrs: {
              name: 'label',
              scaleX: 0.977620730270907,
              scaleY: 0.977620730270907,
              x: options.xmin,
              y: options.ymin
            },
            className: 'Label',
            children: [
              {
                className: 'Text',
                attrs: {
                  fontSize: 10,
                  name: 'text',
                  padding: 3,
                  shadowOffsetX: 0.25,
                  text: 'A1',
                  fill: '#ffff80',
                  fontFamily: 'Verdana',
                  shadowColor: '#000',
                  shadowOffsetY: 0.25
                }
              },
              {
                attrs: {
                  fill: '#ffff80',
                  height: 16,
                  opacity: 0.2,
                  width: 19.193359375
                },
                className: 'Tag'
              }
            ]
          },
          {
            attrs: {
              strokeScaleEnabled: false,
              width: width,
              x: options.xmin,
              y: options.ymin,
              height: height,
              name: 'shape',
              stroke: '#ffff80'
            },
            className: 'Rect'
          }
        ],
        attrs: {
          draggable: true,
          id: id,
          name: 'rectangle-group'
        }
      }

      const drawingsDetails = {
        [id]: {
          meta: {
            quantification: {
              max: {
                unit: '',
                value: 835
              },
              mean: {
                unit: '',
                value: 35.57156308851224
              },
              min: {
                unit: '',
                value: -396
              },
              stdDev: {
                unit: '',
                value: 118.89438119864035
              },
              surface: {
                unit: 'cm²',
                value: 9.122731711266102
              }
            },
            textExpr: `${options.name} ${options.confident} %`
          }
        }
      }
      return { drawing: drawing, drawingsDetails: drawingsDetails }
    },
    // // NOTE เป็น Function ในการเพิ่ม Remove Draw
    // RemoveDraw (data = null, id) {
    //   if (data == null) return console.error('RemoveDraw : data is null')
    //   return data
    // },
    selectedFeatures (val) {
      if (val === 'conference') {
        this.checkStateSelectedFeatures = 1
      } else {
        this.checkStateSelectedFeatures = 2
      }
    },
    onCreateComment (val) {
      // NOTE ทำการ DTO ข้อมูลก่อนส่งไปยัง Parent เพื่อ Call API
      // FIX ทำให้ Update เมื่อ Comment
      this.$emit('createComment', {
        ...val,
        ...{
          user_id: this.storeGetUserInfo.user_id,
          job_id: this.localItems[this.index]?.job_id
        }
      })
    },
    onCreateSubComment (val) {
      // console.log(val)
      // FIX ทำให้ Update เมื่อ Comment
      this.$emit('createSubComment', {
        ...val,
        ...{
          user_id: this.storeGetUserInfo.user_id,
          job_id: this.localItems[this.index]?.job_id
        }
      })
    },
    onUpdateComment (val) {
      // NOTE
      this.$emit('updateComment', val)
    },
    onDeleteMainComment (val) {
      // NOTE
      this.$emit('deleteMainComment', {
        ...val,
        ...{
          user_id: this.storeGetUserInfo.user_id
        }
      })
    },
    onDeleteSubComment (val) {
      this.$emit('deleteSubComment', {
        ...val
        // ...{
        //   user_id: this.storeGetUserInfo.user_id
        // }
      })
    },
    Close () {
      // TODO Reset Value
      this.boxs = []
      this.index = 0
      this.dialog = !this.dialog
      this.$EventBus.$emit('close-ConferenceCall')
      // this.adjusts = JSON.parse(
      //   JSON.stringify([
      //     { text: 'ความสว่าง', value: 100 },
      //     { text: 'ความเข้ม', value: 100 }
      //   ])
      // )
    },
    mouseOver (event) {
      // console.log('mouse over')
      // this.elementViewImage.addEventListener('wheel', this.mouseWheel)
    },
    mouseLeave (event) {
      // console.log('mouse leave')
      // this.elementViewImage.addEventListener(
      //   'wheel',
      //   this.debounce(this.mouseWheel, 100)
      // )
    },
    debounce (fn, d) {
      let timer
      return function () {
        const context = this
        const args = arguments
        clearTimeout(timer)
        timer = setTimeout(() => {
          fn.apply(context, args)
        }, d)
      }
    },
    mouseWheel (event) {
      if (event.deltaY > 0) {
        if (this.index < this.localItems.length - 1) this.index++
      }
      if (event.deltaY < 0) {
        if (this.index > 0) this.index--
      }
    },
    async onDrawRectangle (val) {
      console.log('emit', val.children[0].children[0]._partialText, val)
    }
  },
  mounted () {
    //
  }
}
</script>

<style lang="css" scoped>
.text-disabled{
  color: #757575;
}
.main-layout {
  /* background: blue; */
  /* background: var(--v-bgPrimary-base); */
  height: calc(100vh - 64px) !important;
  width: 100%;
  overflow: auto;
}

.full-width-height {
  /* position: relative !important; */
  height: 100% !important;
  width: 100% !important;
  /* background-color: pink; */
  padding: 0;
  margin: 0;
}

::v-deep .card-item {
  height: 100% !important;
  width: 100% !important;
  /* background-color: green !important; */
}
.column-full {
  height: 100%;
}

.card-text {
  overflow: auto;
  height: calc(100% - 64px - 12px);
  /* height: calc(100% - 120px); */
  padding-bottom: 0;
}
.layout-conference {
  overflow: auto;
  /* 48 คือความสูง tab */
  height: calc(100% - 64px - 48px);

  /* height: 50%; */
  /* max-width: ; */
  /* background: lightblue; */
  /* height: 80%; */
  /* height: calc(100% - 120px); */

  /* max-height: 200px; */
  /* height: calc(100% - 64px - 12px); */
  padding-bottom: 0;
}
.layout-comment {
  overflow: scroll;
  height: calc(100% - 120px);
  padding-bottom: 0;
  /* background: #e9ecf8; */
}

/* .v-image {
  border-radius: inherit;
}

.content {
  padding: 12px;
}
.content-details {
  height: 60%;
}

.content-adjusts {
  height: 40%;
}

.content-diagnosis {
  height: 40%;
}
.content-comments {
  height: 60%;
} */

.text-warning {
  color: var(--v-warning-base) !important;
}
.text-success {
  color: var(--v-success-base) !important;
}

.grid-gallery {
  background-color: rgb(225, 225, 225);
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0.5rem;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: repeat(9, 1fr);
  grid-auto-rows: dense;
  grid-auto-flow: dense;
  grid-gap: 0.5rem;
  color: #fff;
  /* text-align: center; */
}

.grid-item {
  /* background-color: #1c304e; */
  border-radius: 1rem;
  overflow: hidden;
  /* overflow-y: auto; */
  width: 100%;
  height: 100%;
}
.grid-item:nth-child(1) {
  grid-row: span 6;
  grid-column: span 2;
}
/* .grid-item-series {
  grid-row: span 10;
  grid-column: span 2;
} */
.grid-item:nth-child(2) {
  grid-row: span 10;
  grid-column: span 6;
}

.grid-item:nth-child(3) {
  grid-row: span 4;
  grid-column: span 2;
}

.grid-item:nth-child(4) {
  grid-row: span 6;
  grid-column: span 2;
}

.grid-item:nth-child(5) {
  grid-row: span 4;
  grid-column: span 2;
}

.grid-item:nth-child(6) {
  grid-row: span 2;
  grid-column: span 6;
}

.grid-item-single {
  grid-row: span 10 !important;
}
.grid-item-series {
  /* background-color: #1c304e; */
  border-radius: 1rem;
  overflow: hidden;
  /* overflow-y: auto; */
  width: 100%;
  height: 100%;
  grid-row: span 10;
  grid-column: span 2;
  /* background: white; */
}
.meet-layout {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
/* .grid-item:nth-child(3),
.grid-item:nth-child(4) {
    grid-row: span 2;
} */

/* เมื่อเป็นน้อยกว่า lg */
@media only screen and (max-width: 1263px) {
  /* .content-details,
  .content-adjusts,
  .content-diagnosis,
  .content-comments {
    height: auto;
  }

  .column-full {
    height: auto;
  } */

  .grid-gallery {
    /* background-color: yellow; */
    grid-template-columns: 100%;
    grid-template-rows: auto;
  }
}
</style>
